import React from 'react';
import ContentPanel from './shared/ContentPanel.jsx';
import ExternalLink from './shared/ExternalLink.jsx';

import prideFlag from '../assets/trans_pride.svg';
import nsfLogo from '../assets/nsf_logo.png';

import './Footer.scss';

const Footer = () => {
  const handleSubmit = (e) => {
    window.open('https://tinyletter.com/wick', 'popupwindow', 'scrollbars=yes,width=800,height=600');
    return true
  }

  return (
    <footer className="Footer">
      <ContentPanel>
        <h3>About</h3>
        <p>
          Crescent Loom is designed and programmed by <ExternalLink href="https://wick.works/about">Olive Perry</ExternalLink>.

          <ExternalLink href="https://wick.itch.io/aesthetic">
            <img className="pride-flag" src={prideFlag} alt='Pride flag' />
          </ExternalLink>

          Development was initially funded via a <ExternalLink href="https://www.kickstarter.com/projects/wickworks/crescent-loom-stitch-muscles-weave-neurons-create">Kickstarter</ExternalLink> in 2016. I would like to come back to this someday with a sequel, but for now I'm only developing it as specific funding/classroom opportunities present themselves.
        </p>

        <p>For problems, questions, or requests, please email <code>olive@wick.works</code></p>

        <p>
          Smaller changes are announced <ExternalLink href="https://bsky.app/profile/wick.works"> via Bsky</ExternalLink> and on the <ExternalLink href="https://wick.itch.io/crescent-loom/devlog">itch.io devlog</ExternalLink> as they happen.
        </p>

        <div className="nsf-container">
          <img className="nsf-acknowledgement" src={nsfLogo} alt='NSF logo' />
          <p>The Sound Localization activity is based upon work supported by the U.S. National Science Foundation under Award No. IOS-2154203.</p>
        </div>

      </ContentPanel>
    </footer>
  );
}

export default Footer ;
